import { userInAdminMode } from 'Helpers/RouteHelpers';
import { periodIsExternalReviewLockedSelector } from 'Store/Areas/Period/PeriodSelectors';
import { currentRouteSelector } from 'Store/Areas/Router/RouteSelectors';

export const userTreePickerSelector = state => state.projects.userTreePicker;

export const shouldRenderBannerSelector = state => !userInAdminMode(currentRouteSelector(state))
  && (userTreePickerSelector(state).canRenderReadOnlyBanner ||
      periodIsExternalReviewLockedSelector(state));
